// extracted by mini-css-extract-plugin
export default {"row":"view-rating-assessment_row__xRYuw"};